import axios from 'axios';
import qs from 'qs';
import $router from '@/router.js'
import { Toast , Dialog } from 'vant';

//测-试
//const debugUrl ="http://39.108.225.0:8080/api/";

// 正式
const debugUrl = "https://www.pantaoyisheng.com/apis/api/";




var token = localStorage.getItem("token");

export default function createRequestHttp (opt) {
    return new Promise(function (resolve, reject) {
        let instance = axios.create();
        instance.defaults.baseURL = debugUrl;

        instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

        if(opt.data && opt.data.token) token = opt.data.token;
        if(!token) token = localStorage.getItem("token");
        
        instance.defaults.headers.common['token'] = token;

        instance.interceptors.request.use(opt=> {
            Toast.loading({
                duration: 0,
                mask: false,
                forbidClick: true,
                loadingType: 'spinner',
                message: '加载中'
            });
            return opt;

        }, function (error) {
            Dialog.alert({
                title: '提示',
                message: '网络异常，请重试'
            }).then(() => {
                $router.replace({
                    name: 'index'
                })
            });
        });


        /****** respone拦截器 ******/
        instance.interceptors.response.use(
            response => {  //成功请求到数据
                Toast.clear('clearAll');
                return response;
            },
            error => {  //响应错误处理
                Toast.clear('clearAll');
                Dialog.alert({
                    title: '提示',
                    message: '网络异常，请重试'
                }).then(() => {
                    $router.replace({
                        name: 'index'
                    })
                });
                   
                
            }
        );


        // 发送请求
        if(opt.method && opt.method == 'post'){ //post
            instance.post(opt.url, qs.stringify(opt.data))
            .then(res => {
                if(res && res.data && res.data.code == 3000 && $router.history.current.name != 'index'){
                    token = '';
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');
                    Toast('登录信息过期，请重新登录');
                    setTimeout(()=>{
                        $router.replace({
                            name: 'index',
                            params: {
                                name: $router.history.current.name
                            }
                        })
                    },1200)
                    
                }
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        }else if(opt.method && opt.method == 'upload'){ //上传图片
            instance.post(opt.url, opt.data)
            .then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        }else{ //get
            let data = qs.stringify(opt.data).length > 0 ? `?${qs.stringify(opt.data)}` : '';
            instance.get(opt.url + data)
            .then(res => {
                if(res && res.data && res.data.code == 3000 && $router.history.current.name != 'index'){
                    token = '';
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');
                    setTimeout(()=>{
                        $router.replace({
                            name: 'index',
                            params: {
                                name: $router.history.current.name,
                                target: $router.history.current.name
                            }
                        })
                    },1200)
                }
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        
        }

    })
}